import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';

@Injectable({
  providedIn: 'root'
})

export class PhoneService {

  constructor(
    private baseClient: BaseclientService
  ) { }

  ckeckPhone(idCountry: any, phone: any): Promise<any> {

    const params = { id_country: idCountry, phone: phone };
    return this.baseClient.postBase("phone", params);
  }

 
}
